module.exports = "<div class='chart-container' #scrollArea>\r\n    <google-chart [data]=\"pieChartData\"></google-chart>\r\n</div>"